import * as React from "react";
const SvgFiRrCartMinus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cart-minus_svg__a)">
      <path
        fill="#062147"
        d="M9 22c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m8-2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6-17h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1m-.8 5.02a.997.997 0 0 0-1.18.78l-.36 1.78a3.01 3.01 0 0 1-2.94 2.41H5.42l-.94-8H12c.55 0 1-.45 1-1s-.45-1-1-1H4.24l-.04-.35A3.004 3.004 0 0 0 1.22-.01H1C.45 0 0 .45 0 1s.45 1 1 1h.22c.51 0 .93.38.99.88l1.38 11.7C3.89 17.1 6.02 19 8.56 19H19c.55 0 1-.45 1-1s-.45-1-1-1H8.56c-1.29 0-2.41-.82-2.83-2h11.99c2.38 0 4.44-1.69 4.9-4.02l.36-1.78c.11-.54-.24-1.07-.78-1.18"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cart-minus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCartMinus;
